import { createListenerMiddleware } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/store/store'
import { getMatterMembers } from '@/matter/fetch/get-matter-members'
import { kMembersCacheDurationMs } from '@/collaboration/constants'
import { CollaborationActions } from './slice'

export const collaborationListenerMiddleware = createListenerMiddleware()
const startListener = collaborationListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()

startListener({
  actionCreator: CollaborationActions.fetchMembers,
  effect: async (action, listenerApi) => {
    const { matterId, force = false } = action.payload
    const entry = listenerApi.getState().collaborationState.membersByMatterId[matterId]

    // Skip a fetch that's already in flight, unless forced. A forced refetch after add/remove
    // must run even during a poll; the requestId guard drops whichever response lands older.
    if (!force && entry?.loading) return
    // Skip while the cached list is still fresh, unless forced.
    if (!force && entry?.lastFetch != null && Date.now() - entry.lastFetch < kMembersCacheDurationMs) return

    const requestId = (entry?.requestId ?? 0) + 1
    listenerApi.dispatch(CollaborationActions.fetchMembersStarted({ matterId, requestId }))

    try {
      const response = await getMatterMembers(matterId)
      listenerApi.dispatch(CollaborationActions.fetchMembersSucceeded({ matterId, members: response.members, requestId }))
    } catch {
      listenerApi.dispatch(CollaborationActions.fetchMembersFailed({ matterId, requestId }))
    }
  },
})
